import React, { useState, useMemo } from 'react';
import { Brushaway, BrushawayHeader, BrushawayBody, BrushawayFooter } from '@ui/molecules/Brushaway';
import { Button } from '@ui';
import { translate } from '@utils/i18n';
import AssetTypeSelector from '@components/v2/AssetTypeSelector';
import './AddAssetExclusionsDrawerStyles.scss';
const namespace = 'features.settings.ai_inspection_manager.missing_information';
export default function AddAssetExclusionsDrawer({ isOpen, onClose, onAdd, existingAssetTypeValues, subtitle }) {
    const [selectedAssetTypes, setSelectedAssetTypes] = useState([]);
    const handleSelectionChange = (assetTypeValues) => {
        setSelectedAssetTypes(assetTypeValues);
    };
    const handleAdd = () => {
        const newAssetTypes = selectedAssetTypes.filter((value) => !existingAssetTypeValues.includes(value));
        if (newAssetTypes.length > 0) {
            onAdd(newAssetTypes);
            setSelectedAssetTypes([]);
        }
    };
    const handleCancel = () => {
        setSelectedAssetTypes([]);
        onClose();
    };
    const selectedCount = useMemo(() => {
        return selectedAssetTypes.filter((value) => !existingAssetTypeValues.includes(value)).length;
    }, [selectedAssetTypes, existingAssetTypeValues]);
    return (React.createElement(Brushaway, { controlledOpen: isOpen, onClose: handleCancel },
        React.createElement(BrushawayHeader, { title: translate('add_asset_exclusions_title', { namespace }) }),
        React.createElement(BrushawayBody, null,
            React.createElement("div", { className: "add-asset-exclusions-drawer__content" },
                React.createElement("div", { className: "add-asset-exclusions-drawer__description" }, subtitle),
                React.createElement(AssetTypeSelector, { selectedAssetTypes: selectedAssetTypes, onSelectionChange: handleSelectionChange }))),
        React.createElement(BrushawayFooter, { startActions: React.createElement("span", null,
                selectedCount,
                " ",
                translate('selected', { namespace: 'features.commons' })) },
            React.createElement("button", { type: "button", className: "qmb-control", onClick: handleCancel }, translate('cancel', { namespace: 'features.commons' })),
            React.createElement(Button, { variant: "primary", onClick: handleAdd, disabled: selectedCount === 0 }, translate('add_assets', { namespace })))));
}
